import { PUBLIC_PATH } from "../constants"

export function shouldHijactZoneDetailPage() {
  const { pathname } = window.location
  // 劫持 zone/detail 路径，兼容旧版本的 zone/detail 路径
  return pathname === '/zone/detail'
}

/**
 * 劫持详情页的路径，兼容旧版本的 zone/detail 路径
 */
// 这个函数会在 main.js 中调用
// 如果是 zone/detail 路径，则将其转换为 /detail?id=xxx 的形式
// 这样可以兼容旧版本的分享链接

export function hijactZoneDetailPage() {
  // 兼容 zone/detail 路径 (PC端历史版本分享的消息是 zone/detail)
  const { search } = window.location
  if (!search) {
    console.warn('search params is empty')
    return
  }
  // 获取 favId 参数，并将其转换为 id 参数
  // 如果没有 favId 参数，则不进行劫持
  // 如果有 favId 参数，则将其转换为 id 参数，并重定向到 /detail?id=xxx 的形式
  // 例如：/zone/detail?favId=12345 -> /detail?id=12345
  // 注意：如果是安卓端，则使用 history.replaceState 来替换当前历史记录
  // 如果是 iOS 或其他浏览器，则使用 location.replace 来重定向
  // 这样可以避免在安卓端出现历史记录问题
  if (!search.includes('favId')) {
    console.warn('favId is not found in search params')
    return
  }
  const searchParams = new URLSearchParams(search)
  const id = searchParams.get('favId')
  if (!id) {
    console.warn('favId is required in search params')
    return
  }
  searchParams.delete('favId')
  searchParams.set('id', id)
  const newSearch = searchParams.toString() ? `?${searchParams.toString()}` : ''
  const url = `${PUBLIC_PATH}#/detail${newSearch}`
  if (isAndroid() && history.replaceState) {
    history.replaceState(null, '', url)
    history.go(0)
  } else {
    location.replace(url)
  }
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent)
}